import React, { PureComponent } from 'react';

import LetterParser from './LetterParser';

const AvatarLetterParser = new LetterParser();

class AvatarLetter extends PureComponent {
  render() {
    const { title, size = 30, alt='Avatar', ...rest } = this.props;

    return (
      <img className="rounded-circle"
        alt={ alt }
        { ...rest }
        src={ AvatarLetterParser.make(title, size) }
      />
    )
  }
}

export {
  AvatarLetterParser
};

export default AvatarLetter;